import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { FluidsInfusionRedLabelAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-fluids-infusion-red-label-slot',
    templateUrl: './fluids-infusion-red-label-slot.component.html',
    styleUrl: './fluids-infusion-red-label-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsInfusionRedLabelSlotComponent implements SheetSlotComponentBase {

	action!: FluidsInfusionRedLabelAction;
	value!: string | null;

	@Input('action') set updateAction(action: FluidsInfusionRedLabelAction | null) {
		this.action = action as FluidsInfusionRedLabelAction;
		this.value = this.action.rate?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}